<div class="header">
    <a routerLink="/">
        <img [src]="logoSrc" alt="Code-A-Cuisine Logo">
    </a>
    @if (backConfig()) {
        <div class="back-btn">
            <button class="action-back-btn" type="button" [attr.aria-label]="backConfig()!.label" (click)="goBack()">
                <app-svg-icon name="back-btn-green" [width]="22" [height]="15"></app-svg-icon>
                <p aria-hidden="true">{{ backConfig()!.label }}</p>
            </button>
        </div>
    }
</div>